import React, { useEffect, useRef } from 'react';
import './Notification.css';

const Notification = ({ message, type = 'error', onClose, duration = 8000 }) => {
  const hasClosedRef = useRef(false);
  const timerRef = useRef(null);
  const closeTimeoutRef = useRef(null);
  const onCloseCalledRef = useRef(false);
  const isClosingRef = useRef(false);
  const elementRef = useRef(null);
  const classAppliedRef = useRef(false);

  const handleClose = () => {
    // Строгая проверка - если уже закрывается, немедленно выходим
    if (hasClosedRef.current || isClosingRef.current || classAppliedRef.current) {
      return;
    }
    
    // Устанавливаем все флаги АТОМАРНО СРАЗУ
    hasClosedRef.current = true;
    isClosingRef.current = true;
    classAppliedRef.current = true;
    
    // Очищаем все таймеры
    if (timerRef.current) {
      clearTimeout(timerRef.current);
      timerRef.current = null;
    }
    
    if (closeTimeoutRef.current) {
      clearTimeout(closeTimeoutRef.current);
      closeTimeoutRef.current = null;
    }
    
    // Вызываем onClose сразу без анимации
    if (!onCloseCalledRef.current) {
      onCloseCalledRef.current = true;
      onClose();
    }
  };

  useEffect(() => {
    // Не запускаем таймер, если уже закрывается или закрыто
    if (duration > 0 && !hasClosedRef.current && !isClosingRef.current && !classAppliedRef.current) {
      timerRef.current = setTimeout(() => {
        handleClose();
      }, duration);
      return () => {
        if (timerRef.current) {
          clearTimeout(timerRef.current);
          timerRef.current = null;
        }
      };
    }
  }, [duration]);

  // Очистка при размонтировании
  useEffect(() => {
    return () => {
      if (timerRef.current) {
        clearTimeout(timerRef.current);
        timerRef.current = null;
      }
      if (closeTimeoutRef.current) {
        clearTimeout(closeTimeoutRef.current);
        closeTimeoutRef.current = null;
      }
    };
  }, []);

  // НЕ применяем класс через className, чтобы избежать повторного применения
  // Класс будет применен напрямую в handleClose через requestAnimationFrame
  // Используем только ref для отслеживания состояния
  
  return (
    <div 
      ref={elementRef}
      className={`notification notification-${type}`}
    >
      <div className="notification-content">
        <span className="notification-icon">
          {type === 'error' && '⚠'}
          {type === 'success' && '✓'}
          {type === 'info' && 'ℹ'}
        </span>
        <span className="notification-message">{message}</span>
        <button 
          className="notification-close" 
          onClick={(e) => {
            e.preventDefault();
            e.stopPropagation();
            handleClose();
          }}
        >
          ×
        </button>
      </div>
    </div>
  );
};

export default Notification;

